import React from 'react';

import { CSVLink } from 'react-csv';
import moment from 'moment';
import 'moment/locale/sv';
import { useTranslation } from '../i18n';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const ExportCSV = ({ books }) => {
  const lang = localStorage.getItem('language');
  const { t } = useTranslation();
  const [csvData, setCsvData] = React.useState([]);

  // Function to convert Firestore Timestamp to a formatted date
  const formatDate = (timestamp) => {
    return moment(timestamp.toDate()).locale(lang).format('D MMM, YYYY');
  };

  const fetchDataFromFirebase = async () => {
    try {
      const dataArray = books.map((data) => {
        return {
          title: data.title || '',
          author: data.author_name || '',
          pages: data.number_of_pages || '',
          isbn: data.isbn || '',
          status: data.status || '',
          pages_read: data.pages || '',
          time_read: data.time || '',
          dateStarted: data.dateStarted ? formatDate(data.dateStarted) : '',
          dateFinished: data.dateFinished ? formatDate(data.dateFinished) : '',
          cover_url: data.cover_url[0] || '',
          sessions: data.sessions
            ? JSON.stringify(data.sessions).replace(/"/g, '""')
            : '',
        };
      });
      setCsvData(dataArray);
    } catch (error) {
      console.error('Error preparing CSV: ', error);
    }
  };

  const handleClick = () => {
    logEvent(analytics, 'account_settings_export_csv');
  };

  React.useEffect(() => {
    fetchDataFromFirebase();
  }, []);

  return (
    <div className="link">
      <CSVLink
        onClick={handleClick}
        data={csvData}
        filename={'my-books-from-bookie.csv'}
        headers={[
          { label: 'Title', key: 'title' },
          { label: 'Author', key: 'author' },
          { label: 'Pages', key: 'pages' },
          { label: 'ISBN', key: 'isbn' },
          { label: 'Status', key: 'status' },
          { label: 'Pages read', key: 'pages_read' },
          { label: 'Time read (sec.)', key: 'time_read' },
          { label: 'Date Started', key: 'dateStarted' },
          { label: 'Date Finished', key: 'dateFinished' },
          { label: 'Cover URL', key: 'cover_url' },
          { label: 'Sessions', key: 'sessions' },
        ]}
      >
        {t.exporttocsv}
      </CSVLink>
    </div>
  );
};

export default ExportCSV;
